<template>
    <div style="background:#fff" class="ve-list-page">
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;border-bottom:2px solid #389;padding-top:3px">
            <div style="min-width:1100px;display:flex">
                <span style=" font-size:12px;margin-right:10px;margin-left:2px;font-weight:600">{{ $LANG('', '字段查询') }}</span>
                <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable  size="small" style="width:150px; ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam" size="small" @keyup.enter.native="qryTabData" style="width:310px; height:30px;  ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input> 

                <el-select v-model="selparam2"  :placeholder="$LANG('1675', '请选择列名')" clearable size="small" style="width:150px; ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam2" size="small" @keyup.enter.native="qryTabData" style="width:310px; height:30px;  ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input> 
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div> 
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
            :table-data="tabData"
            :column-hidden-option="columnHiddenOption"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :max-height="tabHeight"
            :virtual-scroll-option="virtualScrollOption"
            :scroll-width="0"
            :column-width-resize-option="columnWidthResizeOption"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            :cell-selection-option="{ enable: false }"
            v-loading="loading"
            ref="tabref">
        </ve-table>
        </div>
        <div style="line-height:30px;height:35px;font-size:12px; overflow: hidden;display:flex;margin-top:5px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:6px">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="color:#606266; font-size:12px;width:35px;margin-left:10px ;">每页</div>
            <el-select v-model="rowSize" size="small" style="width:80px;margin-right:10px ;"  @change="initPage">
                <el-option 
                    v-for="item in pageList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
 
        </div> 
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确 定') }}</el-button>
            </span>
        </el-dialog>
        <!-- 设计模板 -->
        <workFlow ref="workflowDialog" :dlgWidth="tabWidth" :workFlowTitle="workFlowTitle" :isWorkFlowView="isWorkFlowView"
              @saveWorkflow="handleWorkflowSave"></workFlow>
       
        <el-dialog v-dialogDrag :visible.sync="newWin" :width="tabWidth" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="height:85vh;overflow-y:auto">
             <SnakerFlowDesigner class="flow-chart-readonly"  ref="designer" v-model="flowData" />
             </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="newWin = false">{{ $LANG('1638', '确 定') }}</el-button>
            </span>
        </el-dialog>
        <el-dialog
            v-dialogDrag 
            :visible.sync="routerWin"  
            :width="tabWidth" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            :destroy-on-close="true"
            append-to-body 
            top="1vh"
            @closed="handleRouterDialogClosed">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ isRouterView ? $LANG('', '查看菜单功能流程') : $LANG('', '菜单功能流程设计') }}</span>
            </div>
            <div style="height:85vh;overflow-y:auto">
             <FlowDesigner 
                v-if="routerWin"
                class="flow-chart-readonly" 
                ref="menuFlowDesigner" 
                v-model="flowData" 
                :viewer="isRouterView" 
                @on-save="handleMenuFlowSave" 
                @node-click="handleNodeClick" />
             </div>
            <span slot="footer" v-if="!isRouterView">
                <el-button type="info" size="small" @click="routerWin = false">{{ $LANG('0132', '取 消') }}</el-button>
                <el-button type="primary" size="small" @click="saveMenuFlow">{{ $LANG('0130', '保 存') }}</el-button>
            </span>
            <span slot="footer" v-else>
                <el-button type="primary" size="small" @click="routerWin = false">{{ $LANG('0132', '关 闭') }}</el-button>
            </span>
        </el-dialog>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
    </div>
</template>
<script>
import workFlow from './workFlow.vue'
import { getTabColOrData,getBaseData } from '../../api/user'
import { designWorkflow, handleWorkflowSave as saveWorkflow } from '@/utils/workflowDesigner.js'//局部注册
import SnakerFlowDesigner from "@/components/SnakerFlowDesigner/snakerflow/index.vue";
import FlowDesigner from "@/components/FlowDesigner/index.vue";
import menuFlowDefineService from '@/components/FlowDesigner/menuFlowDefineService'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition } from '@/utils/veTableHeaderQuery'

//局部注册
export default {
    name:"flow_design",
    mixins: [createVeTableFieldSettingMixin({
        settingFormId: '446085',
        fieldIdseq: '446085',
        fieldLstseq: '1',
        mainColumnKey: 'tabArr',
        tableColumnKey: 'vueCol',
        initColumnKey: 'initCol',
        tableRef: 'tabref',
        generatedFixedColumnKeys: ['rownum', 'oper'],
        syncMainColumnSettings: true,
    })],
    data () {
        return {
            routerWin:false,
            isRouterView: false,
            newWin:false,
            flowData:{},
            addWin:false,
            perFlag:'create',
            mthArr:[],
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
    
            isWorkFlowView: false,
            formRow:{},
  
            workFlowTitle: '流程定义',
            active:'', //二级菜单选中标志
            
            disabled:false, //新增权限制
            allData:[],
            pageList: [   {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            v_idseq:'',
            tabData:[], //表数据
            tabArr:[], //表列 
            initCol:[],
            vueCol:[],
            columnHiddenOption: { defaultHiddenColumnKeys: [] },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            virtualScrollOption: { enable: false },
            loading:false,
            v_headerRow:{},
            queryRequestId:0,
            headerSortKey:'',
            headerSortOrder:'',
            operArr:[],           
            comboArr:{},
            oper:'like',
            txtparam:'',
            selparam:'ADDDTTM',
            oper2:'like',
            txtparam2:'',
            selparam2:'',
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid'),//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            imgSrc:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
 
        }
    },
    mounted () { 

        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
 
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','446085','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
 
    },
    computed: {
        tabWidth: function() {
            return (window.innerWidth - 160) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 158) + 'px';
        }, 
        cavHeight: function() {
            return (window.innerHeight - 208) + 'px';
        }, 
    },
    components: {
        workFlow,
        SnakerFlowDesigner,
      // eslint-disable-next-line vue/no-unused-components
        FlowDesigner,
        VeColumnConfigDialog,
    },
    created () {       
        console.log('cook:'+this.v_corpid)
        if (this.v_username){ 
            // Metadata must be ready before the first request builds its conditions.
            this.getTabField()
                .then(() => this.qryTabData())
                .catch(() => this.qryTabData())
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        sortHeaderColumn(column, edcss){
            const key = column && column.key
            if (!key) return
            if (this.headerSortKey === key) {
                this.headerSortOrder = this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            } else {
                this.headerSortKey = key
                this.headerSortOrder = 'asc'
            }
            const direction = this.headerSortOrder === 'asc' ? 1 : -1
            const type = String(edcss || '').toLowerCase()
            this.allData.sort((left, right) => {
                const leftValue = left[key]
                const rightValue = right[key]
                if (leftValue === rightValue) return 0
                if (leftValue === null || leftValue === undefined || leftValue === '') return 1
                if (rightValue === null || rightValue === undefined || rightValue === '') return -1
                if (type === 'number') return (Number(leftValue) - Number(rightValue)) * direction
                if (type === 'date' || type === 'date2' || type === 'time') {
                    return (new Date(leftValue).getTime() - new Date(rightValue).getTime()) * direction
                }
                return String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true }) * direction
            })
            this.initPage()
        },
        rowShow(){
            this.v_headerRow = {}
            this.qryTabData()
        },
        isMetadataKey(key){
            return Boolean(key && /^[A-Za-z0-9_]+$/.test(key)
                && this.tabArr.some(item => item && item.key === key))
        },
        getSortKey(){
            const candidates = [this.selparam, 'ADDDTTM', 'IDSEQ']
            return candidates.find(key => this.isMetadataKey(key)) || 'IDSEQ'
        },
        async saveMenuFlow() {
            try {
                const flowData = this.$refs.menuFlowDesigner.exportData()
                await menuFlowDefineService.delMenuFlow(this.v_idseq)
                if (!flowData || !flowData.nodes || flowData.nodes.length === 0) {
                    this.$message.success('已清空菜单流程')
                    this.routerWin = false
                    this.qryTabData()
                    return
                }
                const result = await menuFlowDefineService.saveMenuFlow(
                    this.v_idseq,
                    flowData.nodes,
                    flowData.edges
                )
                if (result.success) {
                    this.$message.success('菜单流程保存成功')
                    this.routerWin = false
                    this.qryTabData()
                } else {
                    this.$message.error(result.message || '保存失败')
                }
            } catch (error) {
                this.$message.error('保存菜单流程失败: ' + (error.message || '未知错误'))
            }
        },
        
        //加载菜单流程
        async loadMenuFlow(formId) {
            console.log(formId,',id')
            try {
                const flowData = await menuFlowDefineService.getMenuFlowData(formId)
                if (flowData && flowData.nodes && flowData.nodes.length > 0) {
                    this.flowData = flowData
                } else {
                    this.flowData = { nodes: [], edges: [] }
                }
            } catch (error) {
                this.flowData = { nodes: [], edges: [] }
            }
        },
        
        //处理菜单流程保存事件（从组件触发）
        handleMenuFlowSave(graphData) {
            console.log('FlowDesigner 触发保存:', graphData)
            this.saveMenuFlow()
        },
        
        //处理节点点击事件（查看模式下跳转）
        handleNodeClick(nodeData) {
            console.log('节点点击:', nodeData)
            
            // 只在查看模式下处理跳转
            if (!this.isRouterView) {
                return
            }
            
            // 只有表单节点（有 menuUrl）才跳转
            if (nodeData.menuUrl && nodeData.menuUrl.trim()) {
                console.log('跳转到:', nodeData.menuUrl)
                
                // 关闭对话框
                this.routerWin = false
                
                // 使用 Vue Router 跳转
                this.$router.push(nodeData.menuUrl).catch(err => {
                    // 如果路由不存在，显示提示
                    if (err.name === 'NavigationDuplicated' || err.message.includes('Avoided redundant navigation')) {
                        // 已经在当前路由，忽略错误
                        console.log('已在当前页面')
                    } else {
                        this.$message.warning('菜单路径不存在: ' + nodeData.menuUrl)
                    }
                })
            } else {
                // 模块节点没有 URL，提示用户
                this.$message.info('该节点没有配置菜单路径')
            }
        },
        
        //对话框关闭后的清理
        handleRouterDialogClosed() {
            console.log('对话框已关闭，清理数据')
            // 清空流程数据，避免下次打开时显示旧数据
            this.flowData = { nodes: [], edges: [] }
            // 重置查看模式标志
            this.isRouterView = false
        },
        
        //保存流程
        async handleWorkflowSave(obj, deletedNodeIds) {
            await saveWorkflow({
                obj, 
                deletedNodeIds, 
                component: this, 
                axios: this.$axios, 
                baseUrl:'',
                v_idseq:this.v_idseq     
            })
        },
        //表行点击事件
        rowClick(row){
 
        },
  
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current=index
            this.tabData = this.allData.slice(_start,_end)
        },
        // 明细
        getTabList(cond, requestId){
            //获取所有产品记录且初始化分页记录   
            let v_data=[]
            const activeRequestId = requestId || ++this.queryRequestId
            return this.$axios({
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid',p_value: this.v_corpid,p_table:'V_FORM_FLOW'},
            }).then(res=>{       
                if (activeRequestId !== this.queryRequestId) return null
                v_data = Array.isArray(res.result) ? res.result : []
                return this.$axios({
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: {p_key:'isflow',p_value:'Y', p_cond:cond+' order by '+this.getSortKey()+' DESC' ,p_table:'V_SYS_FORM_SET'},
                    }).then(res=>{ 
                        if (activeRequestId !== this.queryRequestId) return null
                        if (String(res.code)==='200'){
                            this.allData = Array.isArray(res.result) ? res.result : []
                            this.allData.forEach(item=>{
                                let flow = v_data.filter(flow=>flow.IDSEQ === item.IDSEQ)
                                if (flow.length>0){
                                    item.ISNODE= flow[0]['ISNODE']
                                    item['SENDER']=flow[0]['SENDER']
                                }else{
                                    item.ISNODE='N'
                                    item['SENDER']=''
                                }
                            })
                            this.initPage()
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }
                        this.$nextTick(() => { //有固定列时 查询后重新布局
                            const table = this.$refs.tabref
                            if (table && typeof table.doLayout === 'function') table.doLayout()
                            if (table && this.allData.length > 0 && typeof table.setHighlightRow === 'function') {
                                table.setHighlightRow({ rowKey: this.allData[0].IDSEQ })
                            }
                        })
                        return res
                })
            }).catch(error => {
                if (activeRequestId !== this.queryRequestId) return null
                this.promptWin = true
                this.prompt = error && error.message ? error.message : this.$LANG('', '查询失败')
                return null
            })
        },
        flowRec(row){
            this.v_idseq = row['IDSEQ']
            this.newWin = true
            // 加载菜单流程数据
            this.$nextTick(() => {
                this.loadMenuFlow(this.v_idseq)
            })
        },
      routerRec(row, viewMode){
         this.v_idseq = row['IDSEQ']
          this.routerWin = true
          this.isRouterView = (viewMode === 'Y') // 是否为查看模式
            this.$nextTick(() => {
                this.loadMenuFlow(this.v_idseq)
            })
        },
        //设计模板
        designRec(row,val){
            this.v_idseq = row['IDSEQ']
            if(val === 'Y'){
                this.isWorkFlowView = false
            }else {
                this.isWorkFlowView = true
            }
            designWorkflow({
                row,
                component: this,
                axios: this.$axios,
                baseUrl: '',
                stfg:val
            })
        },
        editRec(row,val){

            this.saveFlag=false
            this.formRow =JSON.parse(JSON.stringify(row))
            this.addWin=true           
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            const headerCondition = buildVeTableHeaderCondition(this.initCol, this.v_headerRow)
            const toolbarCondition = buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
                + buildVeTableFieldCondition(this.initCol, this.selparam2, this.txtparam2, this.oper2)
            this.current = 1
            this.headerSortKey = ''
            this.headerSortOrder = ''
            const requestId = ++this.queryRequestId
            this.getTabList(headerCondition + toolbarCondition, requestId)
             
        },
        //新增 
        addRec(){
 
            this.addWin =true
            this.stfgCss='icon-weishenhe3'
            this.formRow={}
            this.saveFlag=false
     
        },
 
 
        //获取表列字段
        getTabField(){
            return getTabColOrData(this.v_url,'v_sys_form_fld','idseq','446085','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                this.initCol = res.result || []
                this.tabArr = this.initCol.map(item => Object.assign({}, item, {
                    title: item.title || item.FLDNM,
                    key: item.key || item.FLDNO,
                    align: item.align,
                    width: item.width || item.WIDTH,
                    thide: item.THIDE,
                    fhide: item.FHIDE,
                    edcss: item.EDCSS,
                    disabled: item.DISABLED,
                }))
                this.buildFlowColumns()
                return this.loadInitialFieldSettings()
            })
        },
        buildFlowColumns(){
            const language = this.$store.state.lang
            const dynamicColumns = this.tabArr
                .filter(item => item.thide === 'N')
                .map(item => ({
                    title: this.$translate.getColTitle(item, language),
                    field: item.key,
                    key: item.key,
                    align: item.align,
                    width: Number(item.width) || 120,
                    sortable: false,
                    ellipsis: { showTitle: true },
                    renderHeaderCell: ({ column }) => <VeTableQueryHeader
                        title={column.title}
                        edcss={item.EDCSS || item.edcss}
                        value={this.v_headerRow[item.key]}
                        operator={this.v_headerRow[`#OPER${item.key}`]}
                        sortable={item.key !== 'RN' && item.edcss !== 'checkbox'}
                        sortOrder={this.headerSortKey === item.key ? this.headerSortOrder : ''}
                        titleStyle={{ color: item.key === 'RATIO' ? 'red' : '#03274b' }}
                        on-input={(value) => this.$set(this.v_headerRow, item.key, value)}
                        on-operator-change={(value) => this.$set(this.v_headerRow, `#OPER${item.key}`, value)}
                        on-title-click={() => this.sortHeaderColumn(column, item.EDCSS || item.edcss)}
                        on-query={this.qryTabData}
                    />,
                    renderBodyCell: ({ row }) => {
                        if (item.key === 'ISNODE' && row.ISNODE === 'Y') {
                            return <el-tag size="mini" type="success" effect="dark" style="text-align:center">{this.$LANG('', '已设置')}</el-tag>
                        }
                        if (item.key === 'ISNODE' && row.ISNODE !== 'Y') {
                            return <el-tag size="mini" type="info" effect="dark" style="text-align:center">{this.$LANG('', '未设置')}</el-tag>
                        }
                        return row[item.key]
                    },
                }))
            const rownumColumn = {
                title: this.$LANG('0310', '序号'),
                field: 'rownum',
                key: 'rownum',
                width: 60,
                align: 'center',
                fixed: 'left',
                disableResizing: true,
                renderHeaderCell: () => (
                    <div>
                        <div style="margin-top:3px">{this.$LANG('0310', '序号')}</div>
                        <el-link on-click={this.rowShow} style="font-size:12px;color:#404eff;height:30px">
                            <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip>
                        </el-link>
                    </div>
                ),
                renderBodyCell: ({ rowIndex }) => rowIndex + 1,
            }
            const operationColumn = {
                title: this.$LANG('', '操作'),
                field: 'oper',
                key: 'oper',
                width: 240,
                align: 'center',
                fixed: 'right',
                disableResizing: true,
                renderBodyCell: ({ row }) => this.renderFlowOperations(row),
            }
            this.vueCol = [rownumColumn].concat(dynamicColumns, [operationColumn])
        },
        renderFlowOperations(row){
            const links = []
            if (row && row.ISNODE === 'Y') {
                links.push(
                    <span key="view-flow">
                        <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link disabled={this.editBool} underline={false} on-click={() => this.designRec(row, 'Y')}>
                            <span style="font-size:12px;margin-right:10px;">{this.$LANG('', '查看流程')}</span>
                        </el-link>
                    </span>
                )
            }
            if (row && row.FRMURL) {
                links.push(
                    <span key="design-flow">
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link disabled={this.editBool} underline={false} on-click={() => this.designRec(row, 'N')}>
                            <span style="font-size:12px;margin-right:5px;">{this.$LANG('', '设计流程')}</span>
                        </el-link>
                    </span>,
                    <span key="workflow">
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link disabled={this.editBool} underline={false} on-click={() => this.flowRec(row, 'N')}>
                            <span style="font-size:12px;margin-right:5px;">{this.$LANG('', '工作流')}</span>
                        </el-link>
                    </span>
                )
            } else {
                links.push(
                    <span key="route-map">
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link disabled={this.editBool} underline={false} on-click={() => this.routerRec(row, 'N')}>
                            <span style="font-size:12px;">{this.$LANG('', '路由地图')}</span>
                        </el-link>
                    </span>
                )
            }
            return <div>{links}</div>
        }
    }
}
</script>
<style scoped lang="less">
    /* 流程图组件 100% 填充 */
    ::v-deep .fullscreen-dialog .flow-chart-readonly,
    ::v-deep .fullscreen-dialog .SnakerFlowDesigner,
    ::v-deep .fullscreen-dialog .SnakerFlowDesigner > div {
        width: 100% !important;
        height: 100% !important;
        flex: 1;
        min-height: 0;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        height:25px;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
 
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
